<template>
    <card type="projects-filter">
        <form @submit.prevent>
            <div class="row">
                <div class="col-lg-8 ml-auto mr-auto">
                    <base-input label="Project full name">
                        <div class="custom-selector">
                            <div class="selector-box">
                                {{project_name}}
                            </div>
                        </div>
                        <ul class="selector-list">
                            <li class="selector-item"
                                v-for="elem in projects"
                                :key="elem.project_id"
                                :class="{'selector-item-inactive' : elem.is_active !== '1'}"
                                @click="switchProject(elem.project_id, elem.full_name)">{{elem.full_name}}</li>
                            <li class="selector-item"  @click="switchProject(0)">Empty project</li>
                        </ul>
                    </base-input>
                </div>
            </div>
        </form>
    </card>
</template>

<script>
import {getCookie} from "../../plugins/axios";

export default {
    props: ['projects','curProject'],
    name: "projects-filter",
    data(){
        return{
            currentProject: 0,
            project_name : "Empty"
        }
    },
    methods:{
        switchProject(id, name){
            const selector = document.querySelector(".custom-selector");
            const list = document.querySelector(".selector-list");
            selector.classList.remove("custom-selector-active");
            list.classList.remove("selector-list-active");
            this.project_name = name;
            this.$emit('change-project', id);
        },
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            const project_index = that.projects.findIndex((elem) => (parseInt(elem.project_id) === parseInt(that.curProject)))
            that.project_name = that.projects[project_index].full_name
        }, 2000)
        const selector = document.querySelector(".custom-selector");
        const list = document.querySelector(".selector-list");
        selector.addEventListener("click", () => {
            selector.classList.toggle("custom-selector-active");
            list.classList.toggle("selector-list-active")
        })
    },
    created() {
        this.currentProject = this.curProject;

    }
}
</script>

<style scoped>
option{
    font-size: 16px;
    color: #8348e8;;
}
select{
    height: 50px;
    font-size: 16px;
}
.custom-selector {
    width: 100%;
    height: 40px;
    border: 1px solid #344675;
    border-radius: 5px;
    background-color: transparent;
    display: block;
    position: relative;
}
.custom-selector-active {
    border: 1px solid #e14eca;
}
.selector-box {
    padding-left: 20px;
    position: absolute;
    top: 50%;
    left:0;
    transform: translate(0, -50%);
    width: 100%;
    cursor: pointer;
    display: flex;
    color: #FFFFFF;
}
.selector-box::after {
    content: ">";
    width: 20px;
    position: absolute;
    top: 50%;
    left:100%;
    transform: translate(-20px, -50%);
}
.selector-list {
    list-style: none;
    margin: 0 15px 0 15px;
    padding: 15px;
    border: 1px solid #344675;
    border-radius: 5px;
    height: 0;
    opacity:0;
    pointer-events: none;
    overflow-y: auto;
}
.selector-list-active {
    display: block;
    pointer-events: auto;
    opacity:1;
    height: 250px;
}
.selector-item {
    font-size: 15pt;
    border-bottom: 1px solid #344675;
    padding-left: 10px;
    cursor: pointer;
}
.selector-item-inactive {
    color: #6c757d!important;
}
</style>
